export const PDFMenu = {
    JOB_DETAILS_PDF: 'Job Details PDF',
    ORDER_ACKNOWLEDGEMENT_PDF: 'Quote PDF',
    JOB_TOPDOWN_LAYOUT_PDF: 'Job Topdown Layout PDF',
    CUSTOMER_INVOICE_PDF: 'Tax Invoice PDF',
    ROOM_PLANNER_PDF: 'Room Planner PDF',
};

export const viewPdf = (row: {id: number}, option: string): void => {
    switch (option) {
        case PDFMenu.ORDER_ACKNOWLEDGEMENT_PDF:
            window.open(`/orderAcknowledgementPdf.php?jobId=${row.id}`);
            break;

        case PDFMenu.JOB_TOPDOWN_LAYOUT_PDF:
            window.open(`/jobTopDownLayoutPDF.php?jobId=${row.id}`);
            break;

        case PDFMenu.CUSTOMER_INVOICE_PDF:
            window.open(`/jobPDF.php?jobId=${row.id}`);
            break;

        case PDFMenu.JOB_DETAILS_PDF:
            window.open(`/v2/pdf/preview/${row.id}`);
            break;
    }
};
